module.exports = __webpack_public_path__ + "img/test.9fc5cc84.png";